<template>
    <v-dialog v-model="dialog" width="600" persistent>
        <v-card>
            <v-card-title>{{ $t('cookieNotice') }}</v-card-title>
            <v-divider></v-divider>
            <v-card-text class="mt-5">
                <p>
                    {{ $t('cookieUsage') }}
                </p>
                <div>
                    {{ $t('readAboutOurCookiePolicy') }}
                    <a href="/cookie-policy">
                        {{ $t('linkHere') }}
                    </a>
                </div>
                <div>
                    {{ $t('readAboutOurPrivacyPolicy') }}
                    <a href="/privacy-policy">
                        {{ $t('linkHere') }}
                    </a>
                </div>
            </v-card-text>
            <v-divider></v-divider>
            <div class="d-flex pa-5">
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="acceptCookies">{{ $t('acceptCookies') }}</v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>
<script setup>
const dialog = ref(false)

const cookieConsent = useCookie('visuado-cookie-consent')

onMounted(() => {
    if (!cookieConsent.value) {
        dialog.value = true
    }

    if (cookieConsent.value === 'accepted') {
        dialog.value = false
    }
})

const acceptCookies = () => {
    cookieConsent.value = 'accepted'
    dialog.value = false
}
</script>
